<template>
    <div class="logo">
        <!-- <image-contain :width="szie" :height="szie" :src="config.web_logo" /> -->
        <!-- <image-contain :width="szie" :height="szie" :src="form.website_logo" /> -->

        <transition name="title-width">
            <div
                v-show="showTitle"
                class="logo-title overflow-hidden whitespace-nowrap"
                :class="{ 'text-white': theme == ThemeEnum.DARK }"
                :style="{ left: `${14}px` }"
            >
                <!-- <overflow-tooltip
                    :content="title || config.web_name"
                    :teleported="true"
                    placement="bottom"
                    overflo-type="unset"
                >
                </overflow-tooltip> -->
                <overflow-tooltip
                    :content="title || form.systeam_name"
                    :teleported="true"
                    placement="bottom"
                    overflo-type="unset"
                >
                </overflow-tooltip>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import useAppStore from '@/stores/modules/app'
import { ThemeEnum } from '@/enums/appEnums'
// 获取配置信息
import { recordsConfig } from '@/api/config'
import { RecordsConfigEnum } from '@/enums/appEnums'
const loading = ref(true)
onMounted(() => {
    getRecordsConfig()
})

// 获取配置信息
const getRecordsConfig = () => {
    const { COMPANY } = RecordsConfigEnum
    const type = COMPANY
    const params = {
        type
    }
    recordsConfig(params)
        .then((data) => {
            // console.log(data, '获取data')
            const { company } = data
            form.value = { ...company }
        })
        .finally(() => {
            loading.value = false
        })
}
const form = ref({
    company_name: '', //公司名称
    systeam_name: '', // 系统名称
    website_logo: '', //网站LOGO
    icp_code: '', //网站备案号
    company_address: '', //公司地址
    postal_code: '', //邮政编码
    phone: '', //服务热线
    email: '', //联系邮箱
    index_url: '' //公司首页链接
})

defineProps({
    szie: { type: Number, default: 34 },
    title: { type: String },
    theme: { type: String },
    showTitle: { type: Boolean, default: true }
})
const appStore = useAppStore()
const config = computed(() => appStore.config)
</script>
<style lang="scss" scoped>
.logo {
    height: var(--navbar-height);
    overflow: hidden;
    @apply flex items-center p-2 relative;
    .logo-title {
        // width: 70%;
        position: absolute;
        @apply text-xl;
    }

    .title-width-enter-active {
        opacity: 0;
        transition: all 0.3s ease-out;
    }

    .title-width-leave-active {
        transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .title-width-enter-from,
    .title-width-leave-to {
        width: 0;
        opacity: 0;
    }
}
</style>
